export const CHEER_MSGS = [
  '오늘도 화이팅! 잘 할 수 있어!💪',
  '엄마는 항상 네 편이야 💕',
  '넌 정말 대단해! 오늘도 멋지게! ✨',
  '우리 아이 최고야! 사랑해 💖',
  '힘들어도 조금만 더 힘내보자! 🌟',
  '네가 노력하는 걸 다 알고 있어 😊',
  '오늘 하루도 건강하고 즐겁게! 🌈',
  '실수해도 괜찮아, 배우는 거야! 🌱',
  '어려워도 넌 할 수 있어! 🍀',
  '자랑스러워, 사랑해! 🏆',
  '오늘도 씩씩하게! 파이팅! 🎉',
  '할 수 있어! 믿어! 🔥',
  '한 걸음씩, 이룰 수 있어! 🚀',
  '오늘 하루도 수고했어! 고마워! 💝',
  '항상 응원하고 있어, 파이팅! 🌠',
];

